export default __webpack_public_path__ + "static/media/enviar.ddbd50f8.png";